// @ts-check

import { sourceType } from './sourceType';

/**
 * @module files/FileRepoFile
 */

import { fileErrors } from './validation';

/** Class representing a file repo file */
export default class FileRepoFile {
    /**
     * Create a CourseFile
     * @param {Object} params
     * @param {string} params.id
     * @param {string} params.name
     * @param {string} params.mimeType
     * @param {string} params.signedFileRepoId
     * @param {string} params.signature
     * @param {string} params.error
     */
    constructor({
        id,
        name,
        mimeType,
        signedFileRepoId,
        signature,
        error,
    }) {
        this.id = id;
        this.name = name;
        this.sourceType = sourceType.local;
        this.mimeType = mimeType;
        this.signedFileRepoId = signedFileRepoId;
        this.signature = signature;
        this.error = error;
    }

    /**
     * Create a CourseFile from a file repo response
     * @param {Object} response
     * @param {string} response.fileGuid
     * @param {string} response.fileName
     * @param {string} response.mimeType
     * @param {string} response.signedFileRepoId
     * @param {string} response.signedGuid
     * @param {string} response.error
     */
    static fromFileRepo(response) {
        let error = null;

        if (response.error) {
            const errorName = {
                'InvalidPathCharacters': fileErrors.invalidFileName,
                'ExtensionNotAllowed': fileErrors.invalidExtension,
                'FileSizeTooLarge': fileErrors.tooLarge,
                'FileSizeTooSmall': fileErrors.tooSmall,
            }[response.error];

            error = errorName === undefined ? 'unknown' : errorName;
        }

        return new FileRepoFile({
            id: response.fileGuid,
            name: response.fileName,
            mimeType: response.mimeType,
            signedFileRepoId: response.signedFileRepoId,
            signature: response.signedGuid,
            error,
        });
    }
};
